import { getCurrentInstance } from 'vue'

export default function useCheckTrail() {
	const app = getCurrentInstance()
	const { $axios, $q, $route } = app.appContext.config.globalProperties

	const checkTrail = async () => {
		try {
			if ($route.params.id_trail) {
				$q.loading.show()
				await $axios.get(
					`/etraining_trails/trails/${$route.params.id_trail}/check_trail_user_result/`
				)
			}
		} catch (e) {
			console.log(e)
		} finally {
			$q.loading.hide()
		}
	}

	return checkTrail
}
